/* BMnex — reusable side-arrow slider.
   Wires the left/right arrows of every [data-bmnex-slider] to scroll its
   [data-bmnex-track] by one "page" of cards. Touch/trackpad swipe is native
   (the track is overflow-x:auto). No dependencies; safe to run on every page.
   Arrows auto-hide when the track doesn't overflow, and disable at each end. */
(function () {
  'use strict';

  function pageStep(track) {
    var first = track.children[0];
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 14;
    var cardWidth = first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.85;
    // Scroll by roughly one card, but never a tiny hop nor more than the viewport.
    return Math.min(Math.max(cardWidth, track.clientWidth * 0.4), track.clientWidth);
  }

  function init(slider) {
    if (slider.dataset.bmnexSliderReady === '1') return;
    var track = slider.querySelector('[data-bmnex-track]');
    if (!track) return;
    slider.dataset.bmnexSliderReady = '1';

    var prev = slider.querySelector('.bmnex-slider__arrow--prev');
    var next = slider.querySelector('.bmnex-slider__arrow--next');

    function refresh() {
      var overflow = track.scrollWidth - track.clientWidth;
      var scrollable = overflow > 4;
      // Nothing to scroll (grid mode or too few cards) → hide both arrows.
      if (prev) prev.hidden = !scrollable;
      if (next) next.hidden = !scrollable;
      if (!scrollable) return;
      var x = track.scrollLeft;
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= overflow - 2;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -pageStep(track), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: pageStep(track), behavior: 'smooth' });
      });
    }

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          refresh();
          ticking = false;
        });
      },
      { passive: true }
    );

    // Re-evaluate after layout settles (fonts/images) and on resize.
    window.addEventListener('resize', refresh);
    if (window.ResizeObserver) {
      try {
        new ResizeObserver(refresh).observe(track);
      } catch (e) {}
    }
    window.addEventListener('load', refresh);
    refresh();
  }

  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-bmnex-slider]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });

  // Theme editor: sections re-render on edit.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
